import React, { useState } from "react";
import {
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import ArchiveContainer from "../../../../../file/containers/ArchiveContainer";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import LinkIcon from '@material-ui/icons/Link';
import "./UrlMultiInput.css";
import LinkManager from "../../../../../navigation/LinkManager/LinkManager";

export const UrlMultiInput = ({ url, onChange, setImage, path, target = '_blank', onOpen = null, externalSourceOnly = false, margin = true, cropSizes = null, linkHelper = false, rowStyle = {}, colStyle = {} }) => {
  const [vaultOpen, setOpen] = useState(false);
  const [linkHelperOpen, setLinkeHelperOpen] = useState(false);
  const toggle = () => {
    setOpen(!vaultOpen);
    if (onOpen && typeof onOpen == 'function') onOpen(!vaultOpen);
  }
  const toggleLinkHelper = () => setLinkeHelperOpen(!linkHelperOpen);

  const handlePaste = () => {
    navigator.clipboard.readText().then(text => {
      if (text.includes("https://") || text.includes("data:image/")) {
        if (path) {
          onChange(null, text, path)
        } else {
          onChange(text);
        }
      }
    });
  };
  const setLink = (obj) => {
    if (path) {
      onChange(null, obj.currentLink, path)
    } else {
      onChange(obj.currentLink);
    }
  }
  const handleInput = (e) => {
    let text = e.target.value
    if (path) {
      onChange(null, text, path)
    } else {
      onChange(text);
    }
  };
  return (
    <Row style={{ ...rowStyle, marginTop: margin === false ? '0px' : "15px" }}>
      <Col className="list-setting-item-title" style={colStyle}>
        <InputGroup>
          <Input autoComplete="jirango-nofill" onChange={(e) => handleInput(e)} value={url || ""} />
          {externalSourceOnly === false ? <InputGroupAddon onClick={toggle} addonType="append">
            <InputGroupText
              className="jirango-prepend"
              style={{ backgroundColor: "#fff", cursor: "pointer", border: '1px solid #e4e7ea' }}
            >
              <i className="fa fa-folder prepend-icon" />
            </InputGroupText>
          </InputGroupAddon> : null}
          {linkHelper === true ? <InputGroupAddon onClick={toggleLinkHelper} addonType="append">
            <InputGroupText
              className="jirango-prepend"
              style={{ backgroundColor: "#fff", cursor: "pointer", border: '1px solid #e4e7ea' }}
            >
              <LinkIcon style={{ fontSize: '18px' }} />
            </InputGroupText>
          </InputGroupAddon> : null}
        </InputGroup>
        <p
          className="text-muted"
          style={{ lineHeight: "initial", marginTop: "5px" }}
        >
          <SystemLabel name="UrlLinkInfo" />
        </p>
      </Col>
      <LinkManager
        setLink={setLink}
        isOpen={linkHelperOpen}
        toggle={toggleLinkHelper}
        selectedLink={{ target, link: url, name: '' }} />
      {vaultOpen ? (
        <ArchiveContainer
          toggle={toggle}
          cropSizes={cropSizes}
          typeRequest="img"
          onUseSelected={setImage}
          showLaunchBtn={false}
          isOpen={vaultOpen}
        />
      ) : null}
    </Row>
  );
};
